export default __webpack_public_path__ + "static/media/whiteLinkIcon.4c0671d9.svg";